export const isAlphabetical = (value) => {
  return /^[a-zA-ZÀ-ÿ ]+$/.test(value)
}

export const isEmail = (value) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)
}
